import { signInWithRedirect } from "aws-amplify/auth";
import { initAmplify } from "./amplify";

/**
 * Redirects the user to Cognito Hosted UI (Japanese UI requested).
 * Ensures Amplify is initialized before invoking Auth APIs.
 */
export async function redirectToHostedUI(): Promise<void> {
  try {
    initAmplify();
  } catch {
    // Amplify may already be initialized; ignore
  }
  await signInWithRedirect({ options: { lang: "ja" } });
}
